/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import HorizontalBar from 'components/shared/percentagebar/horizontal/horizontal';
import VerticalBar1 from 'components/shared/percentagebar/vertical1/vertical1';
import VerticalBar2 from 'components/shared/percentagebar/vertical2/vertical2';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/percentagebar/percentagebar_styles';
import { createStyles } from 'utils/styles';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ PERCENTAGE BAR : CHILD ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const PercentageBar = (props) => {
	function displayBar() {
        switch (props.type) {
            case 'vertical1':
                return <VerticalBar1 barCoefficient={props.barCoefficient} amount={props.amount} isClicked={props.isClicked} isCorrectAnswer={props.isCorrectAnswer} />;
            case 'vertical2':
                return <VerticalBar2 barCoefficient={props.barCoefficient} amount={props.amount} isClicked={props.isClicked} isCorrectAnswer={props.isCorrectAnswer} />;
            case 'horizontal':
                return <HorizontalBar barCoefficient={props.barCoefficient} amount={props.amount} isClicked={props.isClicked} isCorrectAnswer={props.isCorrectAnswer} />;
            default:
        }
    }
    return(
    	<span className={`${sheet.classes.percentagebar} percentagebar ${props.type} selected-${props.isClicked} correct-${props.isCorrectAnswer}`}>
    		{displayBar()}
        </span>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PercentageBar;
